export default __webpack_public_path__ + "fonts/ptSans/PTSansBold.ttf";